import * as React from "react";
import styled from "react-emotion";

const LogoImg = styled("img")<{ maxHeight?: string; kioskUiLogoWidth?: string; kioskUiLogoHeight?: string }>`
  max-width: ${({ kioskUiLogoWidth }) => kioskUiLogoWidth || "30vw"};
  max-height: ${({ maxHeight, kioskUiLogoHeight }) => (kioskUiLogoHeight ? kioskUiLogoHeight : maxHeight || "20vh")};
  margin: 1vh;
  filter: drop-shadow(1px 2px black);
  border-radius: 12px;
`;

const Logo: React.SFC<{ border?:boolean;borderColor?: string;logo: string; maxHeight?: string; kioskUiLogoWidth?: string; kioskUiLogoHeight?: string }> = ({
  border,
  borderColor,
  logo,
  maxHeight,
  kioskUiLogoWidth,
  kioskUiLogoHeight,
  ...props
}) => (
  <LogoImg
    src={logo}
    alt="logo"
    maxHeight={maxHeight}
    kioskUiLogoWidth={kioskUiLogoWidth}
    kioskUiLogoHeight={kioskUiLogoHeight}
    {...props}
    style={{ width: kioskUiLogoWidth, height: kioskUiLogoHeight, border:border?"3px solid "+ (borderColor?borderColor: "#5cba0e"):"none" }}
  />
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.tsx